<template>
      <div >
        <FORM  ref="childForm"  @formclick="formclick" :formData="formData"></FORM>
        <br/>
        <span style="color:#909399;font-size: 13px; margin-left: 50px;">{{$t('analyse.accountDataTable.updateTime')}} {{time}}</span>
        <div id="main" style="width:90%; height: 500px; margin-top: 50px; margin-left: 20px;"></div>

        <span style="color:#909399;font-size: 15px; font-weight: bold; margin-left: 50px;">{{$t('analyse.accountDataTable.detail')}}</span>
        <el-button type="primary" style="float:right;"  @click="exportData()" v-auth="'analyse:dealHand:export'">{{$t('analyse.accountDataTable.export')}}</el-button>
        <el-table  :data="tableData" style="width: 100%;margin-left: 70px;"  :default-sort = "{prop: 'date', order: 'descending'}">
          <el-table-column  prop="handMoney"  :label="$t('analyse.realTable.realHandCount')"    />
          <el-table-column  prop="handAccount"  :label="$t('analyse.realTable.realAccount')"  sortable/>
          <el-table-column  prop="handCount"  :label="$t('analyse.realTable.realCount')"  sortable/>
        </el-table>
      </div>

</template>

<script>
    //交易平台
    let platforms={};
    //产品类型
    let productTypes={};
    //产品
    let products={};
    //table封装组件
    import URL from '@/views/analyse/util/url'
    import FORM from '@/components/page/form.vue'
    import download from '@/utils/download'
    import DateUtil from '@/utils/IM/tradeDataUtil.js'
    import Qs from 'qs'
    import axios from 'axios'
    import echarts from 'echarts'
    export default {
        components: {
            FORM
        },
        data() {
            return {
                tableData:{},
                time:'',

                formData:{
                    cols:[
                        { title: window.$t("analyse.realTable.time"), field: 'time',type:6},
                        { title: window.$t("analyse.depositTable.inChannel"), field: 'platform',type:2,optionList:this.platforms},
                        { title: window.$t("analyse.realTable.productType"), field: 'productType',type:2,optionList:this.productTypes},
                        { title: window.$t("analyse.realTable.tradeConfig"), field: 'product',type:2,optionList:this.products},
                        {click: window.$t("common.search"),auth:'analyse:dealHand:sel'}
                    ]
                },

            }
        },
        mounted(){
            this.$axios.get(URL.realVn.getData).then(res => {
                if (res.code == 0) {
                    this.platforms=res.result.platforms;
                    this.productTypes=res.result.productTypes;
                    this.products=res.result.product;
                    this.formData.cols =[
                        { title: window.$t("analyse.depositTable.inChannel"), field: 'platform',type:2,optionList:this.platforms},
                        { title: window.$t("analyse.realTable.productType"), field: 'productType',type:2,optionList:this.productTypes},
                        { title: window.$t("analyse.realTable.tradeConfig"), field: 'product',type:2,data:[],optionListArrRender:(model,col)=>{
                                let productType=model.productType;
                                if(productType!=undefined && productType !=null){
                                    for(let i of this.products){
                                        for(let key in i){
                                            if(productType == key){
                                                return i[key];
                                            }
                                        }
                                    }
                                }
                                return [];
                            }},
                        {click: window.$t("common.search"),auth:'analyse:dealHand:sel'}
                    ];
                }
            });
                },
        methods: {
            checkbox(row){
                this.deleteIds = row.map(key => key.id).join(",");
            },
            exportData(){
                let startTime=null;
                let endTime=null;
                if(this.formData.cols[0].data!=undefined){
                    startTime=this.formData.cols[0].data[0];
                    endTime=this.formData.cols[0].data[1];
                }
                let platform=this.formData.cols[1].data;
                let productType=this.formData.cols[2].data;
                let product=this.formData.cols[3].data;
                if((startTime!=undefined && endTime!=undefined) ||platform!=undefined ||productType!=undefined ||product!=undefined ) {
                    if (platform == undefined)
                        platform = "";
                    if (productType == undefined)
                        productType = "";
                    if (product == undefined)
                        product = "";
                    if (startTime == undefined)
                        startTime = null;
                    if (endTime == undefined)
                        endTime = null;
                    let urlLast = "";
                    if (startTime != null && endTime != null) {
                        urlLast = "&startTime=" + startTime + "&endTime=" + endTime;
                        download.exportExcel(URL.realVn.dealHandExport + "?platform=" + platform+"&productType="+productType+"&tradeConfig="+product+urlLast, {}, "交易手数分析信息");
                    } else {
                        download.exportExcel(URL.realVn.dealHandExport, {}, "交易手数分析信息");
                    }
                }else {
                    download.exportExcel(URL.realVn.dealHandExport, {}, "交易手数分析信息");
                }
            },
            //柱图
            drawDar(id,optionVar) {
                this.charts = echarts.init(document.getElementById(id));

                // 指定图表的配置项和数据
               // var option = {
               //      title: {
               //          text: '存款金额分布'
               //      },
               //      tooltip: {
               //          trigger: 'axis',
               //          axisPointer: {
               //              type: 'shadow'
               //          }
               //      },
               //      grid: {
               //          left: '3%',
               //          right: '10%',
               //          bottom: '55%',
               //          containLabel: true
               //      },
               //      xAxis: {
               //          type: 'value',
               //          boundaryGap: [0, 0.01]
               //      },
               //      yAxis: {
               //          type: 'category',
               //          data: ['巴西', '印尼', '美国', '印度', '中国', '世界人口(万)']
               //      },
               //      series: [
               //          {
               //              type: 'bar',
               //              data: [18203, 23489, 29034, 104970, 131744, 630230]
               //          }
               //      ]
               //  };

                this.charts.setOption(optionVar);
            }, /*查询表单按钮点击事件*/
            formclick(clickName, data){
                if(clickName == "查询" || window.$t("common.search") == clickName){
                    this.getDeposit(data);
                }
            },
            getDeposit(data){
                if((data.timeStart!=undefined && data.timeEnd!=undefined)||data.platform!=undefined || data.product !=undefined|| data.productType !=undefined) {
                    if (data.platform == undefined)
                        data.platform = "";
                    if (data.product == undefined)
                        data.product = "";
                    if (data.productType == undefined)
                        data.productType = "";
                    if(data.timeStart==undefined)
                        data.timeStart=null;
                    if(data.timeEnd==undefined)
                        data.timeEnd=null;
                    let urlLast="";
                    if(data.timeStart!=null && data.timeEnd !=null){
                        urlLast="&startTime=" + data.timeStart + "&endTime=" +  data.timeEnd;
                    }
                    this.$axios.get(URL.realVn.dealHand + "?platform=" + data.platform+"&tradeConfig="+data.product+"&productType="+data.productType +"&type="+type+urlLast).then(res => {
                        if (res.code == 0) {
                            this.time = res.result.time;
                            this.tableData = res.result.details;
                            let drawDar = res.result.drawDar;
                            this.$nextTick(function () {
                                this.drawDar('main', drawDar);
                            });
                        }
                    });
                }else{
                    this.$axios.get(URL.realVn.dealHand).then(res => {
                        if (res.code == 0) {
                            let drawDar = res.result.drawDar;
                            this.time = res.result.time;
                            this.tableData = res.result.details;
                            this.$nextTick(function () {
                                this.drawDar('main', drawDar);
                            });
                        }

                    });
                }
            }
        }

    }
</script>
